import { render, staticRenderFns } from "./FileCountGraph.vue?vue&type=template&id=b167ca58&scoped=true"
import script from "./FileCountGraph.vue?vue&type=script&lang=ts"
export * from "./FileCountGraph.vue?vue&type=script&lang=ts"
import style0 from "./FileCountGraph.vue?vue&type=style&index=0&id=b167ca58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b167ca58",
  null
  
)

export default component.exports